import { richTextToPlainText } from "../../utils/richTextHelpers";

export default function PlainTextEditor({
  value,
  onChange,
  placeholder = "",
  minHeight = 120,
  c,
  onSelectionChange,
  ariaLabel,
}) {
  const plainValue = richTextToPlainText(value);

  const reportSelection = (event) => {
    if (!onSelectionChange) return;
    const { selectionStart = 0, selectionEnd = 0, value: currentValue = "" } = event.currentTarget;
    onSelectionChange({
      start: selectionStart,
      end: selectionEnd,
      text: selectionStart === selectionEnd ? "" : currentValue.slice(selectionStart, selectionEnd),
    });
  };

  return (
    <textarea
      aria-label={ariaLabel || placeholder || "Texteditor"}
      value={plainValue}
      onChange={(event) => onChange?.(event.target.value)}
      onSelect={reportSelection}
      onKeyUp={reportSelection}
      onClick={reportSelection}
      placeholder={placeholder}
      style={{
        width: "100%",
        minHeight,
        padding: 12,
        boxSizing: "border-box",
        resize: "vertical",
        border: `1.5px solid ${c.borderSecondary || c.border}`,
        borderRadius: 8,
        background: c.bg,
        color: c.text,
        fontFamily: "monospace",
        fontSize: 12.5,
        lineHeight: 1.8,
        whiteSpace: "pre-wrap",
        outline: "none",
      }}
    />
  );
}
